import React from "react";
import { FieldError as AriaFieldError } from "react-aria-components";
import ErrorMessage from "components/ErrorMessage";

type FieldErrorProps = {
  children: React.ReactNode;
};

const FieldError: React.FC<FieldErrorProps> = ({ children }) => (
  <AriaFieldError>
    {({ isInvalid }) =>
      isInvalid && <ErrorMessage className="mt-2">{children}</ErrorMessage>
    }
  </AriaFieldError>
);

export default FieldError;
